var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['button', _vm.type],on:{"click":_vm.clickFn}},[(_vm.noWrap)?_vm._t("default"):_c('div',{staticStyle:{"margin-bottom":"4px"}},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }